module.exports = __webpack_public_path__ + "static/media/rp.5bf00825.png";